"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiInputBase = void 0;
var typography_1 = require("../../../theme/global/typography");
var palette_1 = require("../../global/palette");
exports.MuiInputBase = {
    root: {
        minWidth: 100,
        minHeight: 48,
        '&$disabled': {
            color: palette_1.palette.grey[400],
        },
    },
    marginDense: {
        fontSize: typography_1.typography.pxToRem(12),
        minHeight: 40,
        minWidth: 40,
    },
    inputTypeSearch: {
        '&::-webkit-search-cancel-button': {
            '-webkit-appearance': 'none',
            backgroundColor: palette_1.palette.common.white,
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Cpath d='M44.616 5.239a1.313 1.313 0 00-1.857-1.857L24 22.142 5.24 3.382A1.313 1.313 0 003.385 5.24l18.76 18.759-18.76 18.76a1.313 1.313 0 001.857 1.856L24 25.854l18.76 18.76a1.313 1.313 0 001.856-1.857l-18.76-18.759 18.76-18.76z'/%3E%3C/svg%3E\")",
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: "14px 14px",
            borderRadius: '50%',
            height: 14,
            padding: 11,
            width: 14,
            '&:hover': {
                backgroundColor: palette_1.palette.grey[200],
            },
            '&:active': {
                backgroundColor: palette_1.palette.grey[400],
            },
        },
    },
};
